import React, { useEffect } from 'react';
import { tokens as t, fonts as font } from '../../tokens';

const variantMap = {
  success: { bg: t.emeraldLight, color: t.emeraldDeep, border: `${t.emerald}40`, icon: "✓" },
  error:   { bg: t.coralLight,   color: "#9b2412",     border: `${t.coral}40`,   icon: "✕" },
  warning: { bg: t.amberLight,   color: "#92500a",     border: `${t.amber}40`,   icon: "⚠" },
  info:    { bg: t.skyLight,     color: "#1d4ed8",     border: `${t.sky}40`,     icon: "ℹ" },
};

export function Toast({ message, variant = "success", onClose, duration = 4000, icon }) {
  const v = variantMap[variant] || variantMap.success;

  useEffect(() => {
    if (duration > 0 && onClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 10,
      padding: "12px 16px", borderRadius: 10,
      background: v.bg, color: v.color,
      border: `1px solid ${v.border}`,
      fontSize: 13, fontWeight: 500, fontFamily: font.body,
      boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
      animation: "fadeUp 0.25s ease",
      minWidth: 280, maxWidth: 400,
    }}>
      <span style={{ fontSize: 15, flexShrink: 0 }}>{icon || v.icon}</span>
      <span style={{ flex: 1 }}>{message}</span>
      {onClose && (
        <button onClick={onClose} style={{
          background: "none", border: "none", cursor: "pointer",
          color: v.color, fontSize: 15, padding: 0, lineHeight: 1,
          opacity: 0.6, flexShrink: 0,
        }}>×</button>
      )}
    </div>
  );
}

export function ToastContainer({ children, position = "top-right" }) {
  const posMap = {
    "top-right":    { top: 20, right: 20 },
    "top-left":     { top: 20, left: 20 },
    "bottom-right": { bottom: 20, right: 20 },
    "bottom-left":  { bottom: 20, left: 20 },
  };

  return (
    <div style={{
      position: "fixed", zIndex: 400,
      display: "flex", flexDirection: "column", gap: 10,
      ...posMap[position],
    }}>
      {children}
    </div>
  );
}
